// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iOcAe","top":"styles_top__147mj","left":"styles_left__3brvk","description":"styles_description__2V4Ya"};